import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import { useAuthContext } from "./AuthContext";

const SOCKET_URL = "https://socket.xpro.me:3000";
const SocketContext = createContext();

export const useSocketContext = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const { bearerToken, userData } = useAuthContext();
  const [socketInstance, setSocketInstance] = useState(null);

  useEffect(() => {
    if (bearerToken && userData) {
      if (!socketRef.current) {
        const socket = io(SOCKET_URL, {
          transports: ["websocket"],
          auth: { token: bearerToken },
        });

        const company = localStorage.getItem("company");

        socket.on("connect", () => {
          // console.log("WebSocket conectado:", socket.id);

          socket.emit("newUser", {
            id: userData.id,
            name: userData.nome,
            workspace: `${company}.xpro.me`,
          });

          // Apenas loga a quantidade de sessões abertas
          socket.on("users", () => {
            // payload disponível para uso futuro (ex.: contagem de usuários)
          });
        });

        socket.on("connect_error", (error) => {
          console.error("Erro de conexão ao WebSocket:", error);
        });

        socket.on("disconnect", (reason) => {
          // console.log("Desconectado do WebSocket:", reason);
        });

        socketRef.current = socket;
        setSocketInstance(socket);
      }
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
        setSocketInstance(null);
      }
    };
  }, [bearerToken, userData]);

  const emit = (event, data) => {
    socketRef.current?.emit(event, data);
  };

  const on = (event, callback) => {
    socketRef.current?.on(event, callback);
  };

  const off = (event, callback) => {
    socketRef.current?.off(event, callback);
  };

  return (
    <SocketContext.Provider value={{ socket: socketInstance, emit, on, off }}>
      {children}
    </SocketContext.Provider>
  );
};
